import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-redirect-about-us',
  templateUrl: './redirect-about-us.component.html',
  styleUrls: ['./redirect-about-us.component.css']
})
export class RedirectAboutUsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
